import React from 'react';
import './StepIndicator.css';

export type SignificationStep = 'place' | 'narrate';

interface StepIndicatorProps {
  current: SignificationStep;
  hasNarrative: boolean;
}

const STEPS: SignificationStep[] = ['place', 'narrate'];

export const StepIndicator: React.FC<StepIndicatorProps> = ({ current, hasNarrative }) => {
  const steps = hasNarrative ? STEPS : STEPS.slice(0, 1);
  const currentIdx = steps.indexOf(current);

  return (
    <div className="si-bar" role="progressbar" aria-valuenow={currentIdx + 1} aria-valuemax={steps.length}>
      {steps.map((step, i) => (
        <span
          key={step}
          className={`si-dot ${i < currentIdx ? 'si-dot--done' : ''} ${i === currentIdx ? 'si-dot--active' : ''}`}
        />
      ))}
    </div>
  );
};
